import { ActionTypes } from "../../constants/ActionTypes";

// version 1 <--

interface IChatFileUpload {
    file: File,
    roomId: any,
}

export const onGetDisableSendFileInChat = () => {
    return {
        type: ActionTypes.GET_DISABLE_SEND_FILE_IN_CHAT,
    };
};

export const fetchDisableSendFileInChatSuccess = (disableSendFileInChat: boolean) => {
    return {
        type: ActionTypes.FETCH_DISABLE_SEND_FILE_IN_CHAT_SUCCESS,
        payload: disableSendFileInChat
    };
};

export const onChatFileUpload = (model: IChatFileUpload) => {
    return {
        type: ActionTypes.CHAT_FILE_UPLOAD,
        payload: model,
    };
};

export const onChatFileUploadSuccess = () => {
    return {
        type: ActionTypes.CHAT_FILE_UPLOAD_SUCCESS,
    };
};


export const onAddChatImgUrl = (item: any) => {
    return {
        type: ActionTypes.ADD_CHAT_IMG_URL,
        payload: item,
    };
};

export const onClearChatImgUrls = () => {
    return {
        type: ActionTypes.CLEAR_CHAT_IMG_URL,
    };
};

// version 2 <--
export const onGetUserRooms = () => {
    return {
        type: ActionTypes.GET_USER_ROOMS,
    };
};

export const fetchUserRoomsSuccess = (userRooms: any) => {
    return {
        type: ActionTypes.FETCH_USER_ROOMS_SUCCESS,
        payload: userRooms,
    };
};

// ************************************************************************** //

export const onSelectRoom = (room: any) => {
    return {
        type: ActionTypes.SELECT_ROOM,
        payload: room,
    };
};

// ************************************************************************** //

export const onGetNewRoomMessages = (model: any) => {
    return {
        type: ActionTypes.GET_NEW_ROOM_MESSAGES,
        payload: model,
    };
};

export const fetchNewRoomMessagesSuccess = (list: any, roomId: any) => {
    return {
        type: ActionTypes.FETCH_NEW_ROOM_MESSAGES_SUCCESS,
        payload: { list, roomId },
    };
};

// ************************************************************************** //

export const onGetOldRoomMessages = (model: any) => {
    return {
        type: ActionTypes.GET_OLD_ROOM_MESSAGES,
        payload: model,
    };
};

export const fetchOldRoomMessagesSuccess = (list: any, roomId: any) => {
    return {
        type: ActionTypes.FETCH_OLD_ROOM_MESSAGES_SUCCESS,
        payload: { list, roomId },
    };
};

// ************************************************************************** // searchRooms

export const onSearchRooms = (text: string) => {
    return {
        type: ActionTypes.SEARCH_ROOMS,
        payload: text,
    };
};

export const searchRoomsSuccess = (list: any) => {
    return {
        type: ActionTypes.SEARCH_ROOMS_SUCCESS,
        payload: list,
    };
};

// ************************************************************************** // searchRooms

export const onGetRoomByCode = (code: string) => {
    return {
        type: ActionTypes.GET_ROOM_BY_CODE,
        payload: code,
    };
};

// ************************************************************************** //

export const onGetUserInfo = (employeeId: any) => {
    return {
        type: ActionTypes.GET_USER_INFO,
        payload: employeeId,
    };
};

export const fetchUserInfoSuccess = (userInfo: any) => {
    return {
        type: ActionTypes.GET_USER_INFO_SUCCESS,
        payload: userInfo,
    };
};

// ************************************************************************** //

export const onSendTextMessage = (model: any) => {
    return {
        type: ActionTypes.SEND_TEXT_MESSAGE,
        payload: model,
    };
};

export const fetchSendTextMessageSuccess = (msg: any) => {
    return {
        type: ActionTypes.SEND_TEXT_MESSAGE_SUCCESS,
        payload: msg,
    };
};

export const onNotifyNewMessage = (data: any) => {
    return {
        type: ActionTypes.NOTIFY_NEW_MESSAGE,
        payload: data,
    };
};

// ************************************************************************** //

export const onAddNewRoom = (roomId: any) => {
    return {
        type: ActionTypes.ADD_NEW_ROOM,
        payload: roomId,
    };
};

export const fetchAddNewRoomSuccess = (room: any) => {
    return {
        type: ActionTypes.ADD_NEW_ROOM_SUCCESS,
        payload: room,
    };
};

export const clearConversations = () => {
    return {
        type: ActionTypes.CLEAR_CONVERSATIONS_MESSAGES,
    };
};

export const markMessageAsRead = (data: any) => { // data --> roomId, ids
    return {
        type: ActionTypes.MARK_MESSAGE_AS_READ,
        payload: data,
    };
};

export const clearUnreadMessages = (ids: any) => {
    return {
        type: ActionTypes.CLEAR_UNREAD_IDS,
        payload: ids,
    };
};

// ************************************************************************** //

export const onGetUserRoomsWithNewMessage = () => {
    return {
        type: ActionTypes.GET_USER_ROOMS_WITH_NEW_MESSAGE,
    };
};

export const fetchUserRoomsWithNewMessageSuccess = (list: any) => {
    return {
        type: ActionTypes.GET_USER_ROOMS_WITH_NEW_MESSAGE_SUCCESS,
        payload: list,
    };
};

// ************************************************************************** //

export const onGetUserRoomsDetailWithNewMessage = (roomId: any) => {
    return {
        type: ActionTypes.GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE,
        payload: roomId,
    };
};

export const fetchUserRoomsDetailWithNewMessageSuccess = (data: any) => {
    return {
        type: ActionTypes.GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE_SUCCESS,
        payload: data,
    };
};

export const onDeleteUserRoomsDetailWithNewMessage = (roomId: any) => {
    return {
        type: ActionTypes.DELETE_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE,
        payload: roomId,
    };
};


//******************************************************************************* */

export const signalRIsDisconnected = () => {
    return {
        type: ActionTypes.IS_DISCONNECTED,
    };
}